import { sanitizeUrl } from "./util";

export const RECEIVE_DOMAINS = "RECEIVE_DOMAINS";
export const ADD_DOMAIN = "ADD_DOMAIN";
export const REMOVE_DOMAIN = "REMOVE_DOMAIN";
export const UNBLOCK_DOMAIN = "UNBLOCK_DOMAIN";
export const BLOCK_ALL_DOMAINS = "BLOCK_ALL_DOMAINS";

export function receiveDomains(domains) {
	return {
		type: RECEIVE_DOMAINS,
		domains: domains,
	};
}

export function addDomain(domain) {
	return {
		type: ADD_DOMAIN,
		domain: sanitizeUrl(domain),
	};
}

export function removeDomain(domain) {
	return {
		type: REMOVE_DOMAIN,
		domain: domain,
	};
}

export function unblockDomain(domain, unblock_duration_in_minutes) {
	var current_timestamp = new Date().getTime() / 1000;
	var unblock_seconds = unblock_duration_in_minutes * 60;
	return {
		type: UNBLOCK_DOMAIN,
		domain: domain,
		unblock_until_timestamp: current_timestamp + unblock_seconds,
	};
}

export function blockAllDomains() {
	return {
		type: BLOCK_ALL_DOMAINS,
	};
}



// WEBPACK FOOTER //
// ../shared/store/domains/actions.js